import { useRef, useState } from "react";
import TickerAnimation from "../../_utils/TickerAnimation";
import ICONS from "../../../assets/Icons";
import formatDateViewAll from "../../../utils/formatDateViewAll";
import { useNavigate } from "react-router-dom";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../utils/configurationProvider";
import PrimaryButton from "../../_utils/CommonButtons/PrimaryButton";
import { useDispatch, useSelector } from "react-redux";
import SnoozePopup from "../../_utils/SnoozePopup";
import CommonToast from "../../_utils/CommonToast";
import useDynamicRouting from "../../../utils/useDynamicRouting";
import "./index.css";
import IconIndicator from "../../_utils/IconIndicator";
import SVGComponent from "../../_utils/SVGComponent";
import { setNotiID } from "../../../redux/features/Notifications";
import SmallPopup from "../../_utils/CommonSmallPopup";
import globalText from "../../../utils/globalText";
import TitleSubtitlePair from "../../_utils/TitleSubtitlePair";
import CardActionableButton from "../../_utils/CommonViewAllCard/CardSubComponent/CardActionableButton";

const NotificationViewallCard = ({
  onOpenSnoozePopup,
  notificationData,
  isSelectionView,
  isSelected,
  handleSelect,
  handleMarkFavorite,
  lastCard,
  handleUnsnoozeNotification,
  handleSnoozeConfirm,
  notiID,
  popupMode,
  animate,
  popupType,
  handleNavigate,
  testView,
  notificationType,
  moreActionPopup,
  setMoreActionPopup,
  moreActionPopupID,
  setMoreActionPopupID,
  setIsChannelViewAllOpen,
}) => {
  const unsnoozeLockRef = useRef(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { services } = useSelector((state) => state.refreshToken);
  const [showSnoozePopup, setShowSnoozePopup] = useState(false);
  const [data, setData] = useState([]);
  const [tooltip, setTooltip] = useState("Copy to clipboard");
  const copyTextRef = useRef(null);

  const [isalertPopup, setAlertPopUp] = useState(false);
  const [unsnoozingIds, setUnsnoozingIds] = useState([]);

  const addUnsnoozingId = (id) => {
    setUnsnoozingIds((prev) =>
      prev.includes(String(id)) ? prev : [...prev, String(id)],
    );
  };
  const { unsnoozeNotificationLoading } = useSelector(
    (state) => state?.notificationsSlice,
  );

  const { handleDynamicRouting } = useDynamicRouting();

  const handleDynamicRoute = () => {
    handleDynamicRouting(
      notificationData?.eventable_type,
      notificationData?.eventable_id || notificationData?.eventable_ids,
      notificationData?.title,
    );
  };
  const handleUnsnoozeClick = async (e, notificationId) => {
    e.stopPropagation();

    if (popupMode && popupType !== "channelDetailPage") {
      return actionRestricted();
    }

    if (
      unsnoozingIds.includes(String(notificationId)) ||
      unsnoozeLockRef.current ||
      unsnoozeNotificationLoading
    ) {
      return;
    }
    addUnsnoozingId(notificationId);
    unsnoozeLockRef.current = true;
    try {
      dispatch(setNotiID(notificationId));
      await handleUnsnoozeNotification(notificationId);
    } finally {
      unsnoozeLockRef.current = false;
    }
  };
  const handleCopyChannelId = async () => {
    const webhookUrl = data?.id;
    try {
      await navigator.clipboard.writeText(webhookUrl);

      setTooltip("Copied");

      clearTimeout(copyTextRef.current);

      copyTextRef.current = setTimeout(() => {
        setTooltip("Copy to clipboard");
      }, IntervalConfiguration.intervalMedium);
    } catch (error) {
      console.error(error);
    }
  };

  const isAllowed = services?.includes("Notify") || services?.includes("Admin");

  const actionRestricted = () => {
    CommonToast({
      text: "Action restricted in popup mode.",
      icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
      variant: "var(--error)",
    });
  };

  return (
    <>
      {isalertPopup && (
        // Alert popup for leaving the current flow
        <div className="fixed z-z-index-max flex  items-center justify-center  top-left-base left-left-base w-width-full h-height-full bg-custom-backdrop bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle={globalText?.LEAVE_PAGE_WARNING_HEADER}
            headerFontWeight="semibold"
            headerFontColor="emphasis"
            textSize="font-lg"
            subtext="Opening in full view will leave this page and exit the current flow."
            btnOneText="Stay"
            btnOneHandleFunction={() => setAlertPopUp(false)}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Leave"
            btnTwoHandleFunction={() => {
              setAlertPopUp(false);
              navigate(
                handleDynamicRoute(
                  notificationData.eventable_type,
                  notificationData?.eventable_id,
                  notificationData?.eventable_ids,
                ),
              );
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      {showSnoozePopup && (
        <div className="fixed z-z-index-max flex items-center justify-center top-top-base left-left-base w-full h-full bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <SnoozePopup
            headerTitle="snooze notification"
            secondHeaderTitle="Select the date and time to snooze this notification."
            btnOneHandleFunction={() => {
              setShowSnoozePopup(false);
            }}
            notificationIdProp={notificationData?.id}
            initialSnoozedUntil={notificationData?.snoozed_until}
            onConfirm={(id, snoozed_until) => {
              handleSnoozeConfirm(
                snoozed_until,
                notificationData?.id,
                notificationData?.snoozed_until,
              );
              setShowSnoozePopup(false);
            }}
          />
        </div>
      )}

      <div
        style={{ paddingBottom: lastCard ? "var(--padding-md)" : "" }}
        data-notification-id={notificationData?.id}
        onClick={(e) => {
          const isNotSnoozed =
            notificationData?.snoozed_until ===
            GlobalConfiguration.lengthCheckZero;

          e.stopPropagation();
          if (isSelectionView) {
            handleSelect(e, notificationData);
          } else {
            if (
              popupMode &&
              popupType === "channelDetailPage" &&
              isNotSnoozed
            ) {
              setAlertPopUp(true);
              return;
            }
            if (popupMode && isNotSnoozed) {
              actionRestricted();
            } else if (isNotSnoozed) {
              handleNavigate("type", notificationType);

              handleDynamicRoute();
            }
          }
        }}
        className={`cursor-pointer ${
          unsnoozingIds.includes(String(notificationData?.id))
            ? "pointer-events-none"
            : ""
        } ${animate ? (notificationData?.new ? "animate-slideInRight" : "animate-slideOutFromRight") : ""} ${testView ? "animeUp" : ""} flex flex-col rounded-border-radius-md max-w-max-content-width w-full relative`}
      >
        {moreActionPopup && moreActionPopupID === notificationData?.id && (
          <div className="absolute cursor-default right-top_lg top-top_xl w-standard-card-width z-z-index-overlay bg-primary-nav flex flex-col gap-gap-sm  rounded-border-radius-md shadow-box-shadow-right-bottom p-padding-sm">
            <TitleSubtitlePair
              enableTicker={true}
              title={`${data?.target_channel_count} channels`}
              subtitle="Broadcasted channels"
              showArrow={true}
              isDisabled={false}
              hoverOption="white"
              onClick={(e) => {
                e.stopPropagation();
                setMoreActionPopup(false);
                setIsChannelViewAllOpen(true);
              }}
              variant="md"
              titleColor="text-primary"
            />

            <div className="border-b-border border-primary-bg mx-margin-sm"></div>

            <div className="flex flex-col p-padding-sm gap-y-gap-xs ">
              <div className="w-full flex justify-between items-center ">
                <p
                  className={`text-text-primary text-font-sm font-normal flex-1 truncate`}
                >
                  <TickerAnimation text={data?.id} />
                </p>
                <div className="gap-x-gap-sm ml-margin-sm justify-end">
                  <CardActionableButton
                    handleFunction={() => handleCopyChannelId()}
                    icon={
                      tooltip === "Copied"
                        ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                        : ICONS?.COPY
                    }
                    title={tooltip}
                    bgColor="var(--primary-nav-act)"
                  />
                </div>
              </div>
              <p className="text-text-secondary text-font-xs font-normal">
                Notification ID
              </p>
            </div>
          </div>
        )}

        <div
          style={{ paddingBottom: lastCard ? "var(--padding-md)" : "" }}
          className={`absolute ${
            notificationData?.snoozed_until !==
              GlobalConfiguration.lengthCheckZero ||
            unsnoozingIds.includes(String(notificationData?.id))
              ? "flex"
              : "hidden"
          } z-z-index-overlay w-full h-full bg-primary-bg bg-opacity-dark-opacity rounded-border-radius-md justify-between items-center`}
        >
          <div className="flex flex-col gap-y-gap-sm mx-auto">
            <p className="text-text-primary font-semibold text-font-sm">
              Notification snoozed till{" "}
              {formatDateViewAll(notificationData?.snoozed_until, true)}
            </p>
            <div className="flex gap-x-gap-sm mx-auto">
              <PrimaryButton
                isLoaderNeeded={true}
                isLoading={
                  (unsnoozeNotificationLoading &&
                    notiID === notificationData?.id) ||
                  unsnoozingIds.includes(String(notificationData?.id))
                }
                hoverOption="white"
                isDisabled={popupMode && popupType !== "channelDetailPage"}
                handleFunction={(e) => {
                  handleUnsnoozeClick(e, notificationData?.id);
                }}
                btnText="Unsnooze"
                enabledBgColor="var(--primary-nav-act)"
                enabledTextColor="var(--text-primary)"
              />
              {unsnoozeNotificationLoading &&
              notiID === notificationData?.id ? null : (
                <PrimaryButton
                  handleFunction={(e) => {
                    e.stopPropagation();
                    if (popupMode && popupType !== "channelDetailPage") {
                      return actionRestricted();
                    }
                    onOpenSnoozePopup?.(notificationData);
                  }}
                  isDisabled={popupMode && popupType !== "channelDetailPage"}
                  hoverOption="white"
                  btnText="Edit snooze settings"
                  enabledBgColor="var(--primary-nav-act)"
                  enabledTextColor="var(--text-primary)"
                />
              )}
            </div>
          </div>
        </div>
        <div
          className={`notificationCard ${isSelected ? "global-hover-black" : "global-hover-white"} z-z-index-content flex w-full flex-col Qsmd:flex-row gap-y-gap-md rounded-border-radius-md relative ${`${isSelectionView ? ` rounded-border-radius-md ${isSelected ? "bg-positive-bg " : "bg-primary-card"} ` : "bg-primary-card"} ${notificationData?.read ? "bg-opacity-light-opacity" : ""} `}`}
        >
          <div
            className={`${notificationData?.read ? "opacity-dark-opacity" : ""} flex flex-1 min-w-0`}
          >
            <div
              className={`${notificationData?.snoozed_until === GlobalConfiguration.lengthCheckZero ? "Qsmd:py-padding-sm pt-padding-sm px-padding-md" : " px-padding-md pt-padding-md"} flex flex-col  gap-y-gap-xs w-full`}
            >
              <div className="w-full flex justify-between items-center ">
                <div
                  className={`pr-padding-sm ${notificationData?.read ? "hidden" : "flex"}`}
                >
                  <IconIndicator bgColor={"var(--settled)"} />
                </div>
                <p
                  className={`text-font-md flex-1 truncate font-semibold text-text-primary`}
                >
                  <TickerAnimation text={notificationData?.title} />
                </p>
              </div>
              <div className="w-full flex justify-between items-center ">
                <p
                  className={`text-font-md flex-1 truncate font-normal ${notificationData?.read ? "text-text-secondary" : "text-text-primary"}`}
                >
                  <TickerAnimation text={notificationData?.message} />
                </p>
              </div>
            </div>
          </div>
          <div
            className={`${notificationData?.snoozed_until === GlobalConfiguration.lengthCheckZero ? "Qsmd:py-padding-sm pr-padding-md pl-padding-md Qsmd:pl-padding-base pb-padding-sm" : "py-padding-md px-padding-md Qsmd:pr-padding-md"} min-w-min  items-start Qsmd:items-center justify-between flex-row flex gap-x-gap-md shrink-0`}
          >
            <div className="h-full border-r-border border-primary-bg hidden Qsmd:block"></div>
            <div
              className={`${notificationData?.read ? "opacity-dark-opacity" : ""} flex flex-col gap-y-gap-xs justify-evenly`}
            >
              <p
                className={`text-font-sm  truncate font-normal  ${notificationData?.read ? "text-text-secondary" : "text-text-primary"}`}
              >
                {formatDateViewAll(notificationData?.created_at, true)}
              </p>
              <p
                className={`text-font-xs  ${notificationData?.read ? "text-text-secondary" : "text-text-primary"}`}
              >
                Delivered date and time{" "}
              </p>
            </div>
            <div className=" flex items-center  Qsmd:flex-1 gap-x-gap-md pt-padding-base">
              {isSelectionView ? null : (
                <div
                  onClick={(e) => {
                    setMoreActionPopup(false);
                    setMoreActionPopupID("");

                    if (popupMode && popupType !== "channelDetailPage") {
                      return actionRestricted();
                    }

                    e.stopPropagation();

                    if (isAllowed) {
                      onOpenSnoozePopup?.(notificationData);
                    } else {
                      navigate("/feature_not_assigned", {
                        state: { unavailableService: "Notify,Admin" },
                      });
                    }
                  }}
                  title={"Snooze"}
                  className={`h-icon-md w-icon-md ${!isAllowed || (popupMode && popupType !== "channelDetailPage") ? "cursor-not-allowed" : "cursor-pointer "} ${popupMode && popupType !== "channelDetailPage" ? "opacity-light-opacity" : "opacity-base-opacity"}`}
                  alt=""
                >
                  <SVGComponent
                    height="var(--icon-md)"
                    width="var(--icon-md)"
                    color={"var(--text-primary)"}
                    url={ICONS?.SNOOZE}
                    alt="Grid"
                  />
                </div>
              )}
              {isSelectionView ? null : (
                <img
                  onClick={(e) => {
                    setMoreActionPopupID("");
                    setMoreActionPopup(false);
                    e.stopPropagation();
                    if (popupMode && popupType !== "channelDetailPage") {
                      return actionRestricted();
                    }
                    if (isAllowed) {
                      handleMarkFavorite(
                        notificationData?.id,
                        notificationData?.favourite,
                      );
                    } else {
                      navigate("/feature_not_assigned", {
                        state: { unavailableService: "Notify,Admin" },
                      });
                    }
                  }}
                  title={
                    !notificationData?.favourite ? "Favourite" : "Unfavourite"
                  }
                  className={`h-icon-md w-icon-md ${!isAllowed || (popupMode && popupType !== "channelDetailPage") ? "cursor-not-allowed" : "cursor-pointer "} ${popupMode && popupType !== "channelDetailPage" ? "opacity-light-opacity" : "opacity-base-opacity"}`}
                  src={
                    !notificationData?.favourite
                      ? ICONS?.FAVOURITE
                      : ICONS?.FAVOURITE_FILLED
                  }
                  alt=""
                />
              )}

              {isSelectionView ? (
                <img
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSelect(notificationData);
                  }}
                  title={"Select"}
                  className="h-icon-md w-icon-md cursor-pointer self-center notificationIconMobile"
                  src={
                    isSelected
                      ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                      : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE
                  }
                  alt=""
                />
              ) : null}
              {!isSelectionView ? (
                <img
                  onClick={(e) => {
                    e.stopPropagation();
                    setMoreActionPopupID(
                      notificationData?.id !== moreActionPopupID
                        ? notificationData?.id
                        : "",
                    );
                    setMoreActionPopup(
                      notificationData?.id === moreActionPopupID ? false : true,
                    );
                    setData(notificationData);
                  }}
                  title={"More options"}
                  className="h-icon-md w-icon-md cursor-pointer self-center notificationIconMobile"
                  src={"https://q2pay.in/new_assets/mobile/three_dots.svg"}
                  alt=""
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotificationViewallCard;
